export default "/images/patients.svg?1d3889c6149e81d51c88a76e7cd0f44b";